import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Components, Utils, translate } from 'versafleet-core';
import ReduxActions from 'reduxActions';

const TaskArchiveButton = ({
  id = null,
  dispatch,
  dataId,
  strings,
}) => (
  <Components.Archive
    archive={() => {
      dispatch(ReduxActions.task.archive(dataId));
    }}
    archivePath={() => Utils.Router.transitionTo('archives/tasks')}
    delete={async () => {
      await dispatch(ReduxActions.task.delete(dataId));
    }}
    ids={[dataId]}
    modelName={strings.constants.task}
    updateContent={() => {
      dispatch(ReduxActions.task.fetchList());
    }}
  >
    <Components.Button
      className="vf-task__archive-button"
      hint={strings.page.buttons.archive}
      iconClassName="versa-archive"
      id={id}
    />
  </Components.Archive>
);

TaskArchiveButton.displayName = 'Task Archive Button';

TaskArchiveButton.propTypes = {
  dataId: PropTypes.number.isRequired,
  dispatch: PropTypes.func.isRequired,
  id: PropTypes.string,
  strings: PropTypes.shape({
    constants: PropTypes.shape({
      task: PropTypes.string,
    }),
    page: PropTypes.shape({
      buttons: PropTypes.shape({
        archive: PropTypes.string,
      }),
    }),
  }).isRequired,
};

export default connect()(translate('Task')(TaskArchiveButton));
